exports = module.exports = require("../node_modules/.0.21.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".nav-tabs[_v-358f2e7c] {\n  margin-bottom: 15px;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.21.0@css-loader!./~/.7.1.7@vue-loader/lib/style-rewriter.js?id=_v-358f2e7c&file=Tabset.vue&scoped=true!./~/.7.1.7@vue-loader/lib/selector.js?type=style&index=0!./src/Tabset.vue
// module id = 211
// module chunks = 0